import type { UseDisclosureReturn } from '@talos/kyoko';

export interface SupportTicketDialogProps {
  dialog: UseDisclosureReturn;
}

export interface CreateSupportTicketRequest {
  Summary: string;
  Description: string;
  RequestType: 'GeneralQuery' | 'OrderIssue';
  Priority: 'Highest' | 'High' | 'Medium' | 'Low';
  Escalate: boolean;
}

export interface CreateSupportTicketResponse {
  supportLink: string;
}

export interface SupportTicketForm {
  summary: string;
  requestType: string | undefined;
  priority: 'Critical' | 'High' | 'Medium' | 'Low' | undefined;
  description: string;
  pagerDutyAlert: boolean;
}

export type SupportFormArg = {
  [K in keyof Required<SupportTicketForm>]: { key: K; value: SupportTicketForm[K] };
}[keyof SupportTicketForm];

export const availableRequestTypes = ['General query or request', 'Trading or System Issue'];
export const getAvailablePriorities = (requestType: string | undefined): SupportTicketForm['priority'][] => {
  const result: SupportTicketForm['priority'][] = ['High', 'Medium', 'Low'];
  if (!requestType || requestType === 'Trading or System Issue') {
    result.unshift('Critical' as const);
  }
  return result;
};
